import React from "react";
import PropTypes from "prop-types";

import styles from "./HistoryCard.module.css";
import classNames from "classnames";

// Displays action history for an incident.

export function HistoryCard({ history }) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>History of Actions</div>

      <div className={styles.hr} />
      <div className={styles.innerContainer}>
        <div className={styles.content}>
          {history.length > 0 ? (
            <>
              {history.map((item, index) => (
                <div
                  className={classNames(
                    styles.item,
                    index % 2 == 1 && styles.darker
                  )}
                  key={index}
                >
                  <div className={styles.date}>{item.date}</div>
                  <div className={styles.action}>{item.action}</div>
                </div>
              ))}
            </>
          ) : (
            <div className={styles.noHistory}>No history</div>
          )}
        </div>
      </div>
    </div>
  );
}

HistoryCard.propTypes = {
  history: PropTypes.arrayOf(PropTypes.object),
};
